class Cms extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector("form");
  }
  connectedCallback() {
    this.addClass();
    this.generateTable();
    this.removeNbsp();
  }
  addClass() {
    let h1 = this.querySelectorAll("h1");
    let h2 = this.querySelectorAll("h2");
    let h3 = this.querySelectorAll("h3");
    let h4 = this.querySelectorAll("h4");
    let h5 = this.querySelectorAll("h5");
    let h6 = this.querySelectorAll("h6");
    let h = [h1, h2, h3, h4, h5, h6];
    h.forEach((element) => {
      element.forEach((e) => {
        let span2 = document.createElement("span");
        span2.classList.add(`h${e.tagName.slice(1)}`);
        e.replaceWith(span2);
        let p2 = document.createElement("p");
        p2.innerHTML = e.innerHTML;
        span2.appendChild(p2);
      });
    });
    const p = this.querySelectorAll("p");
    p.forEach((element) => {
      if (element.querySelector("img")) {
        element.classList.remove("Paragraph");
      } else {
        element.classList.add("Paragraph");
      }
    });
    let a = this.querySelectorAll("a");
    a.forEach((element) => {
      element.classList.add("Link");
    });
    let span = this.querySelectorAll("span");
    span.forEach((element) => {
      element.classList.add("Span");
    });
    const li = this.querySelectorAll("li");
    li.forEach((element) => {
      element.style.removeProperty("text-align");
      if (element.querySelector("p")) {
        element.querySelector("p").style.removeProperty("text-align");
        element.querySelector("p").classList.remove("Paragraph");
      } else if (element.querySelector("div")) {
        const p2 = document.createElement("p");
        p2.innerHTML = element.querySelector("div").innerHTML;
        element.appendChild(p2);
        element.removeChild(element.querySelector("div"));
      }
    });
    const image = this.querySelector("img");
    const fullWidthMobile = this.querySelector(".full-width-mobile");
    if (image) {
      image.parentElement.classList.add("full-width-mobile");
      image.style.removeProperty("margin");
    }
    if (fullWidthMobile) {
      fullWidthMobile.style.removeProperty("margin");
    }
  }
  /* -------------------------------------------------------------------------- */
  /*                                 Tables tags                                */
  /* -------------------------------------------------------------------------- */
  /**
   * For each table element, create a div element, add a class to it, add a style to it, append the
   * table element to the div element, and append the div element to the page.
   */
  generateTable() {
    const table = this.querySelectorAll("table");
    table.forEach((element) => {
      const tableParent = document.createElement("div");
      tableParent.classList.add("page__table");
      tableParent.style.overflow = "auto";
      tableParent.appendChild(element);
      this.appendChild(tableParent);
    });
  }
  /**
   * It removes all instances of the string '&nbsp;' from all paragraphs in the document.
   */
  removeNbsp() {
    const text = this.querySelectorAll("p");
    text.forEach((element) => {
      if (element.innerHTML.includes("&nbsp;")) {
        element.innerHTML = element.innerHTML.replace(/&nbsp;/g, "");
      }
    });
  }
}
customElements.define("w3-cms", Cms);
